var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_11372",
    "data-name": "\\uADF8\\uB8F9 11372",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8247",
    "data-name": "\\uC0AC\\uAC01\\uD615 8247",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_11372-2",
    "data-name": "\\uADF8\\uB8F9 11372",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19723",
    "data-name": "\\uD328\\uC2A4 19723",
    d: "M24.1,25.05H5.9a.65.65,0,0,1-.65-.65V2a.65.65,0,0,1,.65-.65H24.1a.65.65,0,0,1,.65.65V24.4a.65.65,0,0,1-.65.65M6.55,23.75h16.9V2.65H6.55Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19724",
    "data-name": "\\uD328\\uC2A4 19724",
    d: "M2.325,14.35a.65.65,0,0,1-.65-.65V9.15a.65.65,0,0,1,.65-.65H5.9a.65.65,0,1,1,0,1.3H2.975v3.9a.65.65,0,0,1-.65.65",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19725",
    "data-name": "\\uD328\\uC2A4 19725",
    d: "M27.675,14.35a.65.65,0,0,1-.65-.65V9.8H24.1a.65.65,0,0,1,0-1.3h3.575a.65.65,0,0,1,.65.65V13.7a.65.65,0,0,1-.65.65",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19726",
    "data-name": "\\uD328\\uC2A4 19726",
    d: "M24.1,16.85H5.9a.65.65,0,1,1,0-1.3H24.1a.65.65,0,0,1,0,1.3",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19727",
    "data-name": "\\uD328\\uC2A4 19727",
    d: "M11.425,28.65h-3.9a.65.65,0,0,1-.65-.65V24.4a.65.65,0,0,1,.65-.65h3.9a.65.65,0,0,1,.65.65V28a.65.65,0,0,1-.65.65m-3.25-1.3h2.6v-2.3h-2.6Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19728",
    "data-name": "\\uD328\\uC2A4 19728",
    d: "M22.475,28.65h-3.9a.65.65,0,0,1-.65-.65V24.4a.65.65,0,0,1,.65-.65h3.9a.65.65,0,0,1,.65.65V28a.65.65,0,0,1-.65.65m-3.25-1.3h2.6v-2.3h-2.6Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19729",
    "data-name": "\\uD328\\uC2A4 19729",
    d: "M12.233,22.05H8.9a.65.65,0,0,1,0-1.3h3.333a.65.65,0,1,1,0,1.3",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19730",
    "data-name": "\\uD328\\uC2A4 19730",
    d: "M21.1,22.05H17.767a.65.65,0,1,1,0-1.3H21.1a.65.65,0,0,1,0,1.3",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19731",
    "data-name": "\\uD328\\uC2A4 19731",
    d: "M24.1,6.65H5.9a.65.65,0,0,1,0-1.3H24.1a.65.65,0,0,1,0,1.3",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBus);
export default __webpack_public_path__ + "static/media/iconBus.83ce0fa87ac92b0da6f1e84044b56699.svg";
export { ForwardRef as ReactComponent };